const PORFILE_AVATAR = 'https://cdn-gcp.extramarks.com/stagelocal/images/icons/student_app/{ID}.svg'
const SUBJECT_ICON = 'https://mscontent-gcp.extramarks.com/syllabus_icons/{ID}.svg'





module.exports = {PORFILE_AVATAR,SUBJECT_ICON}